import { isTerminalSupportStatus } from '@formosa/shared/utils/customerServiceEntry';

const STATUS_COPY = {
  WAITING: '正在等待客服人員',
  ASSIGNED: '客服正在加入',
  ACTIVE: '客服服務進行中',
  TRANSFERRING: '正在為您轉接客服',
  REQUEUED: '目前客服已離開，正在重新安排',
  ENDED: '本次客服服務已結束',
  ABANDONED: '本次客服服務已結束',
};

export default function SupportSessionStatusBar({
  session,
  inGrace,
  busy,
  onLeave,
  onEnd,
  onRecontact,
}) {
  if (!session?.sessionId && !session?.status) {
    return null;
  }

  const status = session.status;
  const terminal = isTerminalSupportStatus(status);
  const label = inGrace
    ? '正在重新連線（服務未結束）'
    : (STATUS_COPY[status] || status || '客服會話');

  const agentName = session?.currentAgent?.displayName
    || session?.currentAgent?.username
    || null;

  return (
    <div className="support-status-bar" data-status={status || ''} data-grace={inGrace ? '1' : '0'}>
      <div className="support-status-bar__text">
        <strong>{label}</strong>
        {status === 'ACTIVE' && agentName ? (
          <span> · {agentName}</span>
        ) : null}
        {session.sessionNo ? (
          <small> Session {session.sessionNo}</small>
        ) : null}
      </div>
      <div className="support-status-bar__actions">
        {status === 'WAITING' && onLeave ? (
          <button type="button" className="chat-link-btn" disabled={busy} onClick={onLeave}>
            取消等待
          </button>
        ) : null}
        {!terminal && status !== 'WAITING' && onEnd ? (
          <button type="button" className="chat-link-btn" disabled={busy} onClick={onEnd}>
            結束服務
          </button>
        ) : null}
        {terminal && onRecontact ? (
          <button type="button" className="chat-link-btn" disabled={busy} onClick={onRecontact}>
            再次聯絡
          </button>
        ) : null}
      </div>
    </div>
  );
}
